module.exports =  {
  TITEL: {
    default: 'Hotel suchen | Zehntausende von Hotels in Asien online zur Reservierung',
    detail: '|Hotelreservierung',
  },
  hotel: {
    // Hotel-Suche überarbeitet, neue Übersetzungen - Englisch
    ROOMS: 'Zimmer',
    GUESTS: 'Gäste',
    CHECK_IN_NUM: 'Gäste',
    PREFIX_ADULTS: '',
    SUFFIX_ADULT: 'Erwachsener',
    SUFFIX_ADULTS: 'Erwachsene',
    PREFIX_CHILDREN: '',
    SUFFIX_CHILD: 'Kind',
    SUFFIX_CHILDREN: 'Kinder',
    CHILD_AGE: 'Alter des Kindes',
    NO_MATCH_TIPS: 'Der unten stehende Zimmertyp entspricht nicht der Anzahl der ausgewählten Zimmer und Gäste.',

    Book_Hotel: 'Hotel buchen',
    Select_your_destination: 'Wählen Sie Ihr Ziel aus',
    Please_enter_your_destination: 'Bitte geben Sie Ihr Ziel/Hotel ein',
    Booked_up: 'Ausgebucht',
    Hotel_description: 'Hotelbeschreibung',
    Check_in_date: 'Check-in-Datum',
    Check_out_date: 'Check-out-Datum',
    Sold_out: 'Ausverkauft',
    Non_refundable: 'Nicht erstattbar',
    reserve: 'Buchen',
    Pay_Online: 'Online bezahlen',
    Only_rooms_left_before: 'Nur noch ',
    Only_rooms_left_after: ' Zimmer verfügbar',
    Cancellation_Policy: 'Stornierungsrichtlinie',
    See_all_prices_before: 'Alle ',
    See_all_prices_after: 'Preise anzeigen',
    Estimated_time_of_arrival: 'Geschätzte Ankunftszeit',
    make_your_schedule_well_planned: 'Die Zeit ist für die lokale Zeitzone, bitte planen Sie Ihren Aufenthalt gut und kommen Sie pünktlich an.',
    Hotel_Not_Found: 'Hotel nicht gefunden',
    Please_change_your_search: 'Bitte ändern Sie Ihre Suche',
    Submit_an_application: 'Antrag stellen',
    Hotel_Confirmation: 'Hotelbestätigung',
    Many_Night_Stay_before: '',
    Many_Night_Stay_after: '-Nächte Aufenthalt',
    Hotel_Booking_Number: 'Hotelbuchungsnummer',
    Online_Payment: 'Online-Zahlung',
    The_guest_Room_before: 'Das Gäste[Zimmer',
    The_guest_Room_after: ']',
    Contact_number: 'Kontaktnummer',
    Bring_all_valid_IDs: 'Bitte bringen Sie alle gültigen Ausweise aller Gäste beim Einchecken mit.',
    Hotels_Found_before: '',
    Hotels_Found_after: 'gefundene Hotels',
    Hotels_Presented_before: '',
    Hotels_Presented_center: 'Vorgestellte Hotels (',
    Hotels_Presented_after: ' insgesamt)',
    Please_change_the_dates: 'Zimmer nicht verfügbar an Ihren Daten, bitte ändern Sie die Daten.',
    Login: 'Melden Sie sich in der APP an, um ein Hotel zu buchen',
    Nights_in_total_before: '',
    Nights_in_total_after: 'Nächte insgesamt',
    Location: 'Ort',
    Pictures: 'Bilder',
    Description: 'Beschreibung',
    Policy: 'Richtlinie',
    Check_in_and_check_out_time: 'Check-in und Check-out Zeit',
    Check_in_and_Check_out_before: 'Check-in: nach ',
    Check_in_and_Check_out_center: 'Check-out: vor ',
    Check_in_and_Check_out_after: '',
    Check_in_time: 'Check-in',
    Check_out_time: 'Check-out',
    Facility_Service: 'Einrichtung & Service',
    Payment_methods: 'Zahlungsmethoden akzeptiert vom Hotel',
    Hotel_Address: 'Hoteladresse',
    Pay_online: 'Online bezahlen',
    Pay_offline: 'Offline bezahlen',
    Night_stay_before: '',
    Night_stay_after: '-Nächte Aufenthalt,',
    Rooms_total_before: 'Zimmer',
    Rooms_total_after: 'insgesamt',
    Guest_name_must_be_provided: 'Der vollständige Gastname muss angegeben werden.',
    Please_fill_in_your_contact_number: 'Bitte geben Sie Ihre Kontaktnummer ein',
    Select_estimated_time_of_arrival: 'Wählen Sie die geschätzte Ankunftszeit',
    Number_of_Rooms: 'Anzahl der Zimmer',
    Maximum_guests_per_room_before: 'Maximal ',
    Maximum_guests_per_room_after: ' Gäste pro Zimmer',
    Many_Rooms: ' Zimmer',
    Service_Fee_Included: '(Steuern & Servicegebühr inklusive)',
    Last_Name: 'Nachname',
    First_Name: 'Vorname ',
    Room: 'Zimmer',
    Additional_Tax: 'Zusätzliche Steuer',
    Please_inform_the_hotel: 'Wenn Sie voraussichtlich nach der geschätzten Ankunftszeit ankommen, informieren Sie bitte das Hotel im Voraus.',
    Please_inform_the_hotel_first: 'Die Ankunft im Hotel nach der geschätzten Ankunftszeit, ohne das Hotel im Voraus zu kontaktieren, beeinträchtigt die Verfügbarkeit des Zimmers und des Abendessens. Bitte informieren Sie das Hotel zuerst, um die Verfügbarkeit in solchen Fällen zu bestätigen.',
    Booking_Cancellation: 'Buchungsstornierung',
    Reason_of_Cancellation: 'Grund der Stornierung',
    Incorrect_Information_Filled: 'Falsche Informationen eingegeben',
    Itinerary_Changed: 'Reiseplan geändert',
    Lower_price_on_other_APP: 'Niedriger Preis auf anderer APP',
    Low_quality_hotel: 'Hotel von geringer Qualität',
    Book_at_a_lower_price: 'Buchen Sie zu einem niedrigeren Preis an der Rezeption',
    Other: 'Andere',
    Please_write_your_reason: 'Bitte geben Sie Ihren Grund an',
    After_cancellation_done: 'Nach erfolgter Stornierung wird die Zahlung innerhalb von 3 Werktagen an den ursprünglichen Zahler zurückgegeben.',
    How_to_fill_in_the_guest_name: 'Wie man den Gästenamen ausfüllt',
    It_should_be_exactly_the_same: 'Bitte geben Sie den Gästenamen in englischen Buchstaben für die Hotelreservierung an. Er sollte genau so sein wie auf dem vorgelegten Zertifikat beim Einchecken.',
    How_to_fill_in_a_Chinese_name: 'Wie man einen chinesischen Namen ausfüllt:',
    How_to_fill_in_a_English_name: 'Wie man einen englischen Namen ausfüllt',
    For_example: 'Zum Beispiel: Wenn Ihr chinesischer Name "韩梅梅" ist, ist der Nachname "Han" und der Vorname "Meimei".',
    No_specical_characters: 'Füllen Sie keine Zahlen oder Sonderzeichen aus. ',
    Name_rule_first: 'Der Nachname kommt zuerst, der Vorname folgt, und wenn es einen Mittelnamen gibt, folgt ein Leerzeichen hinter den beiden Namen. ',
    Name_rule_second: 'Zum Beispiel: Green / Jim Stephanie',
    Details: 'Details',
    Pay_now: 'Jetzt bezahlen',
    Hotel: 'Hotel',
    Check_in: 'Einchecken',
    Car: 'Auto',
    All_bookings: 'Alle Buchungen',
    All: 'Alle',
    PROMPT: 'Achtung',


    Search: 'Suche',
    COST_DESCRIPTION: 'Preisdetails',
    TOTAL: 'Gesamt',
    SEE_ORDER_INFO_TO: 'Bezahlen',
    KONW: 'Verstanden',
    BOOKING_INFORMATION: 'Wichtige Informationen',
    Book_Now: 'Jetzt bezahlen',
    MAP: 'Karte',
    CONTACT_INFORMATION: 'Kontaktinformationen',
    LOADING: 'Laden...',
    SORT_FILTER: 'Sortieren/Filtern',
    SCREENING: 'Filtern',
    SEQUENCE: 'Sortieren',
    PHONE_ASK: 'Rufen Sie uns an',
    ABOVE: '',
    SUBMINT_ORDER: 'Einreichen',
    OK: 'OK',
    Order_detail: 'Bestelldetails',
    BOOKING_INFO: 'Buchungsinformationen',
    PAYMENT_AMOUNT: 'Zahlungsbetrag',
    Order_time: 'Buchungszeit',
    ORDER_NUMBERS: 'Buchungsnummer',
    PAY_TYPE: 'Zahlungsmethode',
    BALANCE: 'Saldo',
    CURRENT_BALANCE_BEGIN: 'Saldo',
    OVERPLUS_BALANCE_BEGIN: 'Verbleibend',
    OTHER_PAYMENT: 'Andere Zahlungsmethoden',
    Unionpay: 'UnionPay',
    Wechatpay: 'WeChat-Zahlung',
    Alipay: 'Alipay',
    AGREE_SERVICE_AGREEMENT_BEFORE: 'Durch Klicken auf "Jetzt bezahlen" erklären Sie sich mit den ',
    AGREE_SERVICE_AGREEMENT_AFTER: ' von BaiGolf einverstanden.',
    SERVICE_AGREEMENT: '《Servicevereinbarung》',
    PAYMENT_ORDER: 'Buchungszahlung',
    Total_pay: 'Fälliger Betrag',
    PAY_SUCCESS: 'Zahlung akzeptiert',
    CHECK_THE_ORDER: 'Bestellung überprüfen',
    BACK_TO_INDEX: 'Zurück zur Startseite',
    CANCEL: 'Abbrechen',
    RECOMMED: 'Empfehlen',
    PRICE: 'Preis',
    HIGH: 'Hoch',
    LOW: 'Niedrig',
    RESET: 'Zurücksetzen',
    SELECT_TIME: 'Datum auswählen',
    Hotel_guest: 'Der Gast',
    Select: 'Bitte auswählen',
    Emial_address: 'Bitte geben Sie die E-Mail-Adresse ein',
    Booking_explan: 'Buchungsinformationen',
    VIEW_MORE: 'Mehr anzeigen',
    COLLAPSE: 'Verbergen',
    Week: '',
    Month: '',
    TOURISM_CHECK_IN_HOTEL: 'Einchecken',
    TOURISM_LEAVE_HOTEL: 'Auschecken',
    arrive: 'Ziel',
    Room_description: 'Zimmerbeschreibung',
    Meals: 'Verpflegung',
    Room_Type: 'Zimmertyp',
    BOOKING_EXPLANATION: 'Buchungsinformationen',
    BOOKING_BUTTON: 'Buchen',
    REMIND_SUBMIT_ORDER: 'Weiter',
    login_now: 'Für Hotelreservierungen müssen Sie sich anmelden. Jetzt anmelden?',
    the_real_scene: 'Bilder dienen nur zur Referenz und unterliegen der realen Szene.',
    Bed: 'Bett',
    Rooms: 'Zimmer',
    Room_rate: 'Zimmertarif',
    notified_by_SMS: 'Nach erfolgreicher Reservierung werden Sie per SMS benachrichtigt',
    email_notifications: 'Zur Erhalt von E-Mail-Benachrichtigungen verwenden',
    Booking_deadline: 'Buchungsschluss',
    Child: 'Kind',
    Additional_notes_about_payment: 'Zusätzliche Hinweise zur Zahlung',
    Nights: 'Nächte',
    Minimum_nights_before: 'Mindestens',
    Minimum_nights_after: 'Nächte',
    Size: 'Größe',
    Guests: 'Gäste',
    Room_rate_1: 'Zimmertarif',
    Tax_service_fee: 'Steuern/Servicegebühr',
    Pay_now_1: 'Jetzt bezahlen',
    Filter: 'Filtern',
    Room_rate2: 'Zimmertarif',
    Show_on_map: 'Auf Karte anzeigen',
    Detail: 'Detail',
    Room_Detail: 'Detail',

    TAXES_INCL: 'Inkl. Steuern',
    SEARCH_EMPTY_TIP: 'Entschuldigung, keine Verfügbarkeit an Ihrem ausgewählten Datum. Sie können: alternative Termine oder Hotels suchen',
    severalNight: 'Nächte',
    immediateBooking: 'Jetzt buchen',
    Refundable: 'Erstattbar',
    MORE: 'Mehr',
    adultsCompany: 'Erwachsene',
    ServiceTerms: 'Dienstleistungen & Bedingungen',
    roomPlan: 'Plan',
    guestRoom: 'Zimmer',
    searchAgain: 'Erneut suchen',
    roomNight: 'Zimmer/Nacht',

    NAME_TXT: 'Name',
    HOLDER_NAME: 'Name des Karteninhabers',
    EXPIRATION_DATE: 'Ablaufdatum',
    FORMAT_TXT: 'Format',
    SECURITY_CODE: 'Sicherheitscode',
    MASTER_CARD_NAME: 'Mastercard',
    JCB_CARD_NAME: 'JCB',
    DIGITS_ON_BACK_OF_CARD: 'Die 3 Ziffern auf der Rückseite der Karte.',
    AMERICAN_EXPRESS_NAME: 'American Express',
    FOUR_CAR_NUM_TIPS: '4 Ziffern auf der Vorderseite der Karte',
    ENTER_COMPLETE_CARD_NUM: 'Bitte geben Sie eine vollständige Kartennummer ein.',
    PLEASE_ENTER_HOLDER_NAME: 'Geben Sie den Namen des Karteninhabers ein',
    ENTER_SECURITY_CODE: 'Geben Sie den Sicherheitscode ein',
    ENTER_EXPIRATION_DATE: 'Geben Sie das Ablaufdatum ein',
    ROOM_DETAILS: 'Zimmerdetails',
    CONDITION_CANCEL: 'Erstattbar',
    CHOOSE_PAYMENT_METHOD: 'Zahlung',
    ORDER_TOTAL_LUMP: 'Gesamtbetrag',
    CREDIT_CARD_NUM: 'Debit-/Kreditkartennummer',
    MAINLAND_CARD_ONLY: 'Nur außerhalb des chinesischen Festlandes ausgestellte Bankkarten.',
    SHUT_DOWN: 'Schließen',
    PROVIDER_FROM_CHINA_BANK: 'Zahlungsdienst von B.O.C',

    COUPON: 'Gutschein',
    APPLY_A_COUPON: 'Gutschein anwenden',
    NO_USE: 'Nicht für dieses Angebot gültig.',
    Discard: 'Verwerfen',
    REDEEM: 'Einlösen',
    EMPTY_COUPON: 'Bitte Gutscheincode eingeben',
    NOTICE_COUPON: 'Es kann nur ein Gutschein für jede Buchung eingelöst werden; der Gutschein wird nach Abschluss der Buchung eingelöst.',
    BREAKFAST_INCLUDE: 'Frühstück inbegriffen',
    BREAKFAST_EXCLUDE: 'Frühstück ausgeschlossen',
    DOUBLE_BED: 'Doppelbett',
    TWIN_BED: 'Zweibettzimmer',
    FREE_CANCEL: 'Kostenlose Stornierung',
    MEALS: 'Mahlzeiten',
    EVALUATION: 'Bewertung',
    FEATURED_REVIEWS: 'Hervorgehobene Bewertungen',
    ALL_REVIEWS: 'Alle Bewertungen',
    OVERALL_EVALUATION: 'Gesamtbewertung',
    ANONYMOUS: 'Anonym',
    EVAL_GENERAL_LIST_1: 'Schlecht',
    EVAL_GENERAL_LIST_2: 'Mittelmäßig',
    EVAL_GENERAL_LIST_3: 'Durchschnittlich',
    EVAL_GENERAL_LIST_4: 'Gut',
    EVAL_GENERAL_LIST_5: 'Ausgezeichnet',
    MAX_IMAGES_WITH_NINE: 'Es können maximal 9 Bilder ausgewählt werden.',
    GRADE_EVAL: 'Bitte wählen Sie die Gesamtbewertung',
    DISTANCE_FILTER: 'Entfernung nah-fern',
    EDIT_EVALUATION: 'Kommentar verfassen',
    GO_TO_EVAL: 'Kommentar abgeben',
    EVAL_POINTS_AWARD: 'Gute Kommentare können 1000 Punkte gewinnen, 1000 Punkte = 10 RMB',
    NEARBY_LIKE_HOTEL: 'Ähnliches Hotel in der Nähe',
    DISTANCE_HOTEL: 'zum Hotel',
    PLEASE_ENTER_COMMENT: 'Kommentare',
    AWARD_POINTS_TIPS: 'Die besten Kommentare erhalten 1000 Punkte, 1000 = 10 RMB',
    NO_SHOW_ANONYMOUS_AVATAR: 'Anonyme Kommentare zeigen nicht Ihr Logo und Ihren Namen',
    LOCATION: 'Standort',
    FACILITY: 'Einrichtungen',
    SERVICE: 'Service',
    HEALTH: 'Sauberkeit',
    LANGUAGE_SELECT: 'Sprache',
    LIMIT_COMMENT_TXT: 'Bewertung muss 5–2000 Zeichen haben',
    SHARE_MEDIA: 'Bilder und Videos teilen',
    SETTLEMENT_FEEL: 'Kommentare',
    SUBMIT_EVAL: 'Bestätigen',
    HOTEL_STR: 'Details',
    EVAL_NUM_AFTER: 'Bewertung',
  },
  header: {
    SKIING: 'Skigebiet',
    header_internal_call: 'Festland China:',
    header_abroad_call: 'International:',
    header_app_download: 'Mobile App',
    service_telephone: 'Kundenservice',
    account_number: 'Konto',
    if_bg_user: 'Kein BaiGolf-Mitglied?',
    home: 'Startseite',
    hotel: 'Hotel',
    Golf: 'Golf',
    PLAY_STAY: 'Übernachten & Spielen',
    RENT_CAR_HOME: 'Auto',
    center_user: 'Mitgliederzentrum',
    header_my_order: 'Meine Buchungen',
    header_notmember_order: 'Gastbuchungen',
    header_edit_password: 'Passwort ändern',
    header_logout: 'Ausloggen',
    header_login: 'Anmelden',
    header_register: 'Registrieren',
    header_point: 'Meine Punkte',
    header_all_language: 'Alle Sprachen',
    down_load_app: 'QR-Code scannen, um herunterzuladen',
    login_discount_tip: 'Melden Sie sich an, um Bonuspunkte zu sammeln und exklusive Vorteile zu genießen'
  },
  footer: {
    footer_partner: 'Partner',
    footer_about_us: 'Über uns',
    footer_about_baigolf: 'Über BaiGolf.com',
    footer_privacy_policy: 'Datenschutzrichtlinie von BaiGolf.com',
    footer_use_of_terms: 'Servicebedingungen von BaiGolf.com',
    footer_contact_us: 'Kontaktiere uns',
    footer_sitemap: 'Sitemap',
    footer_use_of_question: 'FAQ',
    footer_ios_system: 'iOS',
    footer_android_system: 'Android',
    footer_app_load: 'APP-Download',
    footer_sina_weibo: 'Sina Weibo',
    footer_tencent_weibo: 'Tencent Mikroblog',
    footer_share_to: 'Teilen',
    copyright1: 'Guangzhou BaiGolf Information Technology Co., Ltd. Copyright ',
    copyright2: 'Yue ICP Anmeldung Nr. 14070002',
    news_center: 'Nachrichtenzentrum',
    about_baigolf: 'Über BaiGolf',
    help: 'Hilfe',
    management_system: 'BG Golf Management System (BGMS)',
    wechat_official_account: 'WeChat Offizielles Konto',
    download_baiGolf_app: 'BaiGolf App herunterladen',
    privacy_policy: 'Datenschutzrichtlinie',
    use_of_terms: 'Servicebedingungen',
    footer_integral: 'Punkterichtlinie',
    footer_reserve: 'Buchungsrichtlinie',
    footer_abroad_call: 'International',
    footer_internal_call: 'Festland China'
  }
}


// WEBPACK FOOTER //
// ./src/lang/german.js